/**
 * @generated SignedSource<<7e2e9e3b575a5f1a68bd927fd79e0d20>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StopBuildProjectIdQuery$variables = {
  buildLocator: string;
  skip: boolean;
};
export type StopBuildProjectIdQuery$data = {
  readonly build?: {
    readonly buildType: {
      readonly project: {
        readonly id: Branded<string, 'ProjectId'> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type StopBuildProjectIdQuery = {
  response: StopBuildProjectIdQuery$data;
  variables: StopBuildProjectIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "buildLocator"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buildLocator",
    "variableName": "buildLocator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StopBuildProjectIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "build",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BuildTypeRest",
                "kind": "LinkedField",
                "name": "buildType",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectRest",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "StopBuildProjectIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "build",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BuildTypeRest",
                "kind": "LinkedField",
                "name": "buildType",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectRest",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "7b2a7a705bea16edb517a72372f9ea8b",
    "id": null,
    "metadata": {},
    "name": "StopBuildProjectIdQuery",
    "operationKind": "query",
    "text": "query StopBuildProjectIdQuery(\n  $buildLocator: String!\n  $skip: Boolean!\n) {\n  build(buildLocator: $buildLocator) @skip(if: $skip) {\n    buildType {\n      project {\n        id\n        _id\n      }\n      _id\n    }\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "19dd560c4abe62f1e18f5e7782796098";

export default node;
